import React from "react";
import { Contact, Header, Hire, ANZSCOItem } from "./Components";
import TwentyNine from "../../Assets/ANZSCO/29.png";
import Thirty from "../../Assets/ANZSCO/30.png";
import ThirtyOne from "../../Assets/ANZSCO/31.png";
import ThirtyTwo from "../../Assets/ANZSCO/32.png";
import ThirtyThree from "../../Assets/ANZSCO/33.png";
import ThirtyFour from "../../Assets/ANZSCO/34.png";
import ThirtyFive from "../../Assets/ANZSCO/35.png";
import ThirtySix from "../../Assets/ANZSCO/36.png";
import ThirtySeven from "../../Assets/ANZSCO/37.png";
import ThirtyEight from "../../Assets/ANZSCO/38.png";
import ThirtyNine from "../../Assets/ANZSCO/39.png";
import Forty from "../../Assets/ANZSCO/40.png";
import FortyOne from "../../Assets/ANZSCO/41.png";
import FortyTwo from "../../Assets/ANZSCO/42.png";
import FortyThree from "../../Assets/ANZSCO/43.png";
import FortyFour from "../../Assets/ANZSCO/44.png";
import FortyFive from "../../Assets/ANZSCO/45.png";
import FortySix from "../../Assets/ANZSCO/46.png";
import FortySeven from "../../Assets/ANZSCO/47.png";
import FortyEight from "../../Assets/ANZSCO/48.png";
import FortyNine from "../../Assets/ANZSCO/49.png";
import Fifty from "../../Assets/ANZSCO/50.png";
import FiftyOne from "../../Assets/ANZSCO/51.png";
import FiftyTwo from "../../Assets/ANZSCO/52.png";
import FiftyThree from "../../Assets/ANZSCO/53.png";
import FiftyFour from "../../Assets/ANZSCO/54.png";

const RPLANZSCO = () => {
  return (
    <div className="servicesPages">
      <Header
        header="RPL ANZSCO Occupation List"
        desc="Discover the complete list of ANZSCO codes for various ICT roles. Select the most appropriate occupation from the list to ensure a successful ACS skills assessment."
      />
      <div className="body">
        <div>
          <div className="header">RPL ANZSCO Code</div>
          <div className="desc">
            The Australian and New Zealand Standard Classification of Occupations (ANZSCO) Codes classify all occupations in Australia and New Zealand. Selecting the correct ANZSCO
            Code is crucial when assessing migration skills for engineers and ICT professionals.
          </div>
          <div className="desc">
            Before applying for a skilled assessment, applicants must choose the appropriate ANZSCO Code. Using the ANZSCO number provided, you can verify your eligibility for the
            correct occupation stream assessed directly by the Australian Computer Society (ACS).
          </div>
          <div className="header">CDR ANZSCO Occupation List</div>
          <div className="items">
            <ANZSCOItem code="ANZSCO 261112" title="System Analyst" img={TwentyNine} />
            <ANZSCOItem code="ANZSCO 261111" title="ICT Business Analyst" img={Thirty} />
            <ANZSCOItem code="ANZSCO 261211" title="Multimedia Specialist" img={ThirtyOne} />
            <ANZSCOItem code="ANZSCO 261212" title="Web Developer" img={ThirtyTwo} />
            <ANZSCOItem code="ANZSCO 261311" title="Analyst Programmer" img={ThirtyThree} />
            <ANZSCOItem code="ANZSCO 263113" title="Network Analyst" img={ThirtyFour} />
            <ANZSCOItem code="ANZSCO 261313" title="Software Engineer" img={ThirtyFive} />
            <ANZSCOItem code="ANZSCO 261314" title="Software Tester" img={ThirtySix} />
            <ANZSCOItem code="ANZSCO 261312" title="Developer Programmer" img={ThirtySeven} />
            <ANZSCOItem code="ANZSCO 262111" title="Database Administrator" img={ThirtyEight} />
            <ANZSCOItem code="ANZSCO 262112" title="ICT Security Specialist" img={ThirtyNine} />
            <ANZSCOItem code="ANZSCO 262113" title="System Administrator" img={Forty} />
            <ANZSCOItem code="ANZSCO 26311" title="Computer Network & Systems Engineer" img={FortyOne} />
            <ANZSCOItem code="ANZSCO 263112" title="Network Administrator" img={FortyTwo} />
            <ANZSCOItem code="ANZSCO 261399" title="Software & App Programmer" img={FortyThree} />
            <ANZSCOItem code="ANZSCO 263211" title="ICT Quality Assurance Engineer" img={FortyFour} />
            <ANZSCOItem code="ANZSCO 263212" title="ICT Support Engineer" img={FortyFive} />
            <ANZSCOItem code="ANZSCO 263213" title="ICT System Test Engineer" img={FortySix} />
            <ANZSCOItem code="ANZSCO 263299" title="ICT Support & Test Engineer (NEC)" img={FortySeven} />
            <ANZSCOItem code="ANZSCO 135111" title="Chief Information Officer" img={FortyEight} />
            <ANZSCOItem code="ANZSCO 135112" title="ICT Project Manager" img={FortyNine} />
            <ANZSCOItem code="ANZSCO 135199" title="ICT Manager (NEC)" img={Fifty} />
            <ANZSCOItem code="ANZSCO 223211" title="ICT Trainer" img={FiftyOne} />
            <ANZSCOItem code="ANZSCO 313113" title="Web Administrator" img={FiftyTwo} />
            <ANZSCOItem code="ANZSCO 224114" title="Data Analyst" img={FiftyThree} />
            <ANZSCOItem code="ANZSCO 224115" title="Data Scientist" img={FiftyFour} />
          </div>
        </div>
      </div>
      <Contact />
      <Hire />
    </div>
  );
};

export default RPLANZSCO;
